import { useSelector } from 'react-redux'
import { SentimentCell } from '../../../../common/news/SentimentCell'
import { selectRecentNewsItem } from './store/slice'

export const Sentiment = ({ val, rowId }) => {
  const newsTypeIds = useSelector(selectRecentNewsItem(rowId, 'newsTypeIds'))

  return <SentimentCell sentimentName={val} newsTypeIds={newsTypeIds} />
}
